// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".suspends{position:fixed;top:0;right:0;width:8.96vw;width:4.2rem;height:5.547vw;height:2.6rem;border-radius:6.667vw;z-index:1!important;background:#39394d;text-align:center;color:#f6d0ab;font-size:3.2vw}.suspends .fontWeight{font-weight:700}p{display:inline-block;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
